import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommunicationService } from '../../services/communication.service';
import { ErrorService } from '../../services/error/error.service';
import { ValidationsService } from 'src/app/services/validations.service';

@Component({
  selector: 'app-reset-password-confirm',
  templateUrl: './reset-password-confirm.component.html',
  styleUrls: ['./reset-password-confirm.component.scss'],
})
export class ResetPasswordConfirmComponent implements OnInit, OnChanges {
  @Output() changeView: EventEmitter<{ id: number; email?: string }>;
  @Input() email: string = '';
  @Input() errorMessage: string = '';
  userEmail: string;
  isLoading: boolean;
  successMessage: string;
  resetFormGroup: FormGroup;

  constructor(private communicationService: CommunicationService, private errorService: ErrorService) {
    this.changeView = new EventEmitter<{ id: number; email?: string }>();
  }

  ngOnInit(): void {
    this.successMessage = '';
    this.isLoading = false;
    this.prepareForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.email) {
      this.userEmail = changes.email.currentValue || '';
      this.prepareForm();
    }
  }

  submitResetRequest(): void {
    if (this.resetFormGroup.valid) {
      const reqObject = {
        email: this.resetFormGroup.value.email,
      };
      this.communicationService.updateData('resetpassword', reqObject).subscribe(
        response => {
          this.errorMessage = '';
          this.successMessage = 'app.user-form.password-successfully-updated';
          this.errorService.throwErrorIfFailure(response, true);
        },
        error => {
          this.errorMessage = 'app.user-form.password-not-updated';
          this.successMessage = '';
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    }
  }

  prepareForm(): void {
    this.resetFormGroup = new FormGroup({
      email: new FormControl(this.userEmail, [Validators.required, ValidationsService.emailValidator()]),
    });
  }

  showLoginForm(): void {
    this.changeView.emit({ id: 0 });
  }

  closeDialog() {
    this.communicationService.dashboardLogoClick(false);
  }
}
